import React, { useState, useEffect, useRef } from 'react';

import Calculate from '../assets/js/calculate';

import { styled } from '@mui/material/styles';

import { Grid, Paper, MenuItem, FormControl, TextField, Select, Button, Typography, FormHelperText, Fade } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

import { useDispatch, useSelector } from 'react-redux';
import { selectCalc, changeCalc } from '../redux/calcSlice';

import shortFields from "../assets/json/shortFields.json";

import { useFormik } from 'formik';

import units from "../assets/json/units.json";
import metals1 from "../assets/json/metals-1.json";
import metals2 from "../assets/json/metals-2.json";
import metals3 from "../assets/json/metals-3.json";

const metals = metals1.concat(metals2, metals3);


/* Filter API 650 Metric Unit grades */

const CalcStd1 = metals.filter(item => item['CalcStd'] === 1);

const CalcSTd1_Austenitic = CalcStd1.filter(item => item['Micro'] === 'Austenitic');
const CalcSTd1_Austenitic_OKGrade = Object.assign({}, ...new Map(CalcSTd1_Austenitic.map(item => 
  [item['OKGrade'], { [item['OKGrade'] ]: CalcSTd1_Austenitic.filter(itm => itm['OKGrade'] === item['OKGrade']) }]
)).values());

const CalcSTd1_Duplex = CalcStd1.filter(item => item['Micro'] === 'Duplex');
const CalcSTd1_Duplex_OKGrade = Object.assign({}, ...new Map(CalcSTd1_Duplex.map(item => 
  [item['OKGrade'], { [item['OKGrade'] ]: CalcSTd1_Duplex.filter(itm => itm['OKGrade'] === item['OKGrade']) }]
)).values());

const CalcSTd1_Carbon = CalcStd1.filter(item => item['Micro'] === 'Carbon');
const CalcSTd1_Carbon_OKGrade = Object.assign({}, ...new Map(CalcSTd1_Carbon.map(item => 
  [item['OKGrade'], { [item['OKGrade'] ]: CalcSTd1_Carbon.filter(itm => itm['OKGrade'] === item['OKGrade']) }]
)).values());


/* EN 14015 Metric Unit grades */

const CalcSTd2 = metals.filter(item => item['CalcStd'] === 2);

const CalcSTd2_Austenitic = CalcSTd2.filter(item => item['Micro'] === 'Austenitic');
const CalcSTd2_Austenitic_OKGrade = Object.assign({}, ...new Map(CalcSTd2_Austenitic.map(item => 
  [item['OKGrade'], { [item['OKGrade'] ]: CalcSTd2_Austenitic.filter(itm => itm['OKGrade'] === item['OKGrade']) }]
)).values());

const CalcSTd2_Duplex = CalcSTd2.filter(item => item['Micro'] === 'Duplex');
const CalcSTd2_Duplex_OKGrade = Object.assign({}, ...new Map(CalcSTd2_Duplex.map(item => 
  [item['OKGrade'], { [item['OKGrade'] ]: CalcSTd2_Duplex.filter(itm => itm['OKGrade'] === item['OKGrade']) }]
)).values());

const CalcSTd2_Carbon = CalcSTd2.filter(item => item['Micro'] === 'Carbon');
const CalcSTd2_Carbon_OKGrade = Object.assign({}, ...new Map(CalcSTd2_Carbon.map(item => 
  [item['OKGrade'], { [item['OKGrade'] ]: CalcSTd2_Carbon.filter(itm => itm['OKGrade'] === item['OKGrade']) }]
)).values());


/* Filter API 650 Customary Unit grades */

const CalcSTd3 = metals.filter(item => item['CalcStd'] === 3);

const CalcSTd3_Austenitic = CalcSTd3.filter(item => item['Micro'] === 'Austenitic');
const CalcSTd3_Austenitic_OKGrade = Object.assign({}, ...new Map(CalcSTd3_Austenitic.map(item => 
  [item['OKGrade'], { [item['OKGrade'] ]: CalcSTd3_Austenitic.filter(itm => itm['OKGrade'] === item['OKGrade']) }]
)).values());

const CalcSTd3_Duplex = CalcSTd3.filter(item => item['Micro'] === 'Duplex');
const CalcSTd3_Duplex_OKGrade = Object.assign({}, ...new Map(CalcSTd3_Duplex.map(item => 
  [item['OKGrade'], { [item['OKGrade'] ]: CalcSTd3_Duplex.filter(itm => itm['OKGrade'] === item['OKGrade']) }]
)).values());

const CalcSTd3_Carbon = CalcSTd3.filter(item => item['Micro'] === 'Carbon');
const CalcSTd3_Carbon_OKGrade = Object.assign({}, ...new Map(CalcSTd3_Carbon.map(item => 
  [item['OKGrade'], { [item['OKGrade'] ]: CalcSTd3_Carbon.filter(itm => itm['OKGrade'] === item['OKGrade']) }]
)).values());


/* Filter order of Austenitic metals */

const sortedMetals = {
  1: {
    "Austenitic": { 
      "Core 304L/4307":[...CalcSTd1_Austenitic_OKGrade["Core 304L/4307"]],
      "Supra 316L/4404":[...CalcSTd1_Austenitic_OKGrade["Supra 316L/4404"]],
      "Supra 316plus":[...CalcSTd1_Austenitic_OKGrade["Supra 316plus"]],
      "Ultra 317L":[...CalcSTd1_Austenitic_OKGrade["Ultra 317L"]],
      "Ultra 904L":[...CalcSTd1_Austenitic_OKGrade["Ultra 904L"]],
      "Ultra 254 SMO":[...CalcSTd1_Austenitic_OKGrade["Ultra 254 SMO"]]
    },

    "Duplex": { ...CalcSTd1_Duplex_OKGrade },
    "Carbon": { ...CalcSTd1_Carbon_OKGrade }
  },
  2: {
    "Austenitic": {
      "Core 304L/4307":[...CalcSTd2_Austenitic_OKGrade["Core 304L/4307"]],
      "Supra 316L/4404":[...CalcSTd2_Austenitic_OKGrade["Supra 316L/4404"]],
      "Supra 316plus":[...CalcSTd2_Austenitic_OKGrade["Supra 316plus"]],
      "Ultra 317L":[...CalcSTd2_Austenitic_OKGrade["Ultra 317L"]],
      "Ultra 904L":[...CalcSTd2_Austenitic_OKGrade["Ultra 904L"]],
      "Ultra 254 SMO":[...CalcSTd2_Austenitic_OKGrade["Ultra 254 SMO"]]
    },

    "Duplex": { ...CalcSTd2_Duplex_OKGrade },
    "Carbon": { ...CalcSTd2_Carbon_OKGrade }
  },
  3: {
    "Austenitic": {
      "Core 304L/4307":[...CalcSTd3_Austenitic_OKGrade["Core 304L/4307"]],
      "Supra 316L/4404":[...CalcSTd3_Austenitic_OKGrade["Supra 316L/4404"]],
      "Supra 316plus":[...CalcSTd3_Austenitic_OKGrade["Supra 316plus"]],
      "Ultra 317L":[...CalcSTd3_Austenitic_OKGrade["Ultra 317L"]],
      "Ultra 904L":[...CalcSTd3_Austenitic_OKGrade["Ultra 904L"]],
      "Ultra 254 SMO":[...CalcSTd3_Austenitic_OKGrade["Ultra 254 SMO"]]
    },
    "Duplex": { ...CalcSTd3_Duplex_OKGrade },
    "Carbon": { ...CalcSTd3_Carbon_OKGrade }
  }
};

const Item = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(4),
  height: '100%'
}));

const DisabledMenuItem = styled(MenuItem)(({ theme }) => ({
  color: theme.palette.background.default,
  background: theme.palette.primary.dark
}));

const DisabledMenuItemHighlighted = styled(MenuItem)(({ theme }) => ({
  color: theme.palette.background.default,
  background: theme.palette.primary.main,
  opacity: '1 !important'
}));

const Calculator = (props) => {
  const firstRender = useRef(true);

  useEffect(() => {
    firstRender.current = false;
  }, [])


  const subBtn = useRef(null);
  const [ triggerSubmit, setTriggerSubmit ] = useState(false);

  useEffect(() => {
    if(triggerSubmit === true) {
      setTriggerSubmit(false);
      subBtn.current?.click();
    }
  }, [triggerSubmit])


  const calc = useSelector(selectCalc);

  useEffect(() => {
    if(calc.submitted) {
      setTimeout(()=>{
        document.getElementById("result-scroll").scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 1000);
    }
  }, [calc.submitted])

  
  const calculate = new Calculate();

  const dispatch = useDispatch();


  const getQueryString = () => {
    if(!window.parent.location.search){ return {}};

    const queryStringKeyValue = window.parent.location.search.split('?')[1].split('&');
    const qsJsonObj = {};
      
    const longFields = Object.assign({}, ...Object.entries(shortFields).map(([a,b]) => ({ [b]: a })));

    if (queryStringKeyValue === '') { return {}};

    for (let i = 0; i < queryStringKeyValue.length; i++) {
      let value = queryStringKeyValue[i].split('=')[1];
      let key = queryStringKeyValue[i].split('=')[0];
      
      if(longFields.hasOwnProperty(key)){
        qsJsonObj[longFields[key]] = !isNaN(value) ? parseInt(value) : decodeURI(value);
      }
    }

    return {...qsJsonObj};
  }
  
  const populateInitalValues = () => {
    if(firstRender.current === true){
      let queryValues = getQueryString();

      if(queryValues.unit && queryValues.steelGrade){
        queryValues.steelGrade = metals.filter((metal, idx) => {
          return (metal.CalcStd === queryValues.unit && metal.OKGradeShort === queryValues.steelGrade );
        });
        
        if(queryValues.unit && queryValues.steelGrade2) {
          queryValues.steelGrade2 = metals.filter((metal, idx) => {
            return (metal.CalcStd === queryValues.unit && metal.OKGradeShort === queryValues.steelGrade2 );
          });
        }

        if(Array.isArray(queryValues.steelGrade2) && queryValues.steelGrade2.length === 0){
          delete(queryValues.steelGrade2);
        }

        dispatch(changeCalc( { ...calc, ...queryValues } ));
        
        if(triggerSubmit === false) {
          setTimeout(()=>{
            setTriggerSubmit(true);
          }, 500);
        }
      }
    }

    return calc;
  }

  const validate = values => {
    const errors = {};
    
    if (!values.temperature && values.temperature !== 0) {
      errors.temperature = 'Required';
    } else if (values.temperature < units[calc.unit]["temperature"]["min"]) {
      errors.temperature = `Must be greater than ${units[calc.unit]["temperature"]["min"]} ${units[calc.unit]["temperature"]["sign"]}`;
    } else if (values.temperature > units[calc.unit]["temperature"]["max"]) {
      errors.temperature = `Must be less than ${units[calc.unit]["temperature"]["max"]} ${units[calc.unit]["temperature"]["sign"]}`;
    }

    if (!values.height && values.height !== 0) {
      errors.height = 'Required';
    } else if (values.height < units[calc.unit]["height"]["min"]) {
      errors.height = `Must be greater than ${units[calc.unit]["height"]["min"]} ${units[calc.unit]["height"]["sign"]}`;
    } else if (values.height > units[calc.unit]["height"]["max"]) {
      errors.height = `Must be less than ${units[calc.unit]["height"]["max"]} ${units[calc.unit]["height"]["sign"]}`;
    }
  
    if (!values.diameter && values.diameter !== 0) {
      errors.diameter = 'Required';
    } else if (values.diameter < units[calc.unit]["diameter"]["min"]) {
      errors.diameter = `Must be greater than ${units[calc.unit]["diameter"]["min"]} ${units[calc.unit]["diameter"]["sign"]}`;
    } else if (values.diameter > units[calc.unit]["diameter"]["max"]) {
      errors.diameter = `Must be less than ${units[calc.unit]["diameter"]["max"]} ${units[calc.unit]["diameter"]["sign"]}`;
    }

    if (!values.density && values.density !== 0) {
      errors.density = 'Required';
    } else if (values.density < units[calc.unit]["density"]["min"]) {
      errors.density = `Must be greater than ${units[calc.unit]["density"]["min"]}`;
    } else if (values.density > units[calc.unit]["density"]["max"]) {
      errors.density = `Must be less than ${units[calc.unit]["density"]["max"]}`;
    }

    if (!Array.isArray(values.steelGrade)) {
      errors.steelGrade = 'Required';
    }
    
    if (!values.plateWidth && values.plateWidth !== 0) {
      errors.plateWidth = 'Required';
    } else if (values.plateWidth < units[calc.unit]["plateWidth"]["min"]) {
      errors.plateWidth = `Must be greater than ${units[calc.unit]["plateWidth"]["min"]}`;
    } else if (values.plateWidth > units[calc.unit]["plateWidth"]["max"]) {
      errors.plateWidth = `Must be less than ${units[calc.unit]["plateWidth"]["max"]}`;
    }
    
    if(Array.isArray(values.steelGrade2)) {
      if (!values.plateWidth2 && values.plateWidth2 !== 0) {
        errors.plateWidth2 = 'Required';
      } else if (values.plateWidth2 < units[calc.unit]["plateWidth"]["min"]) {
        errors.plateWidth2 = `Must be greater than ${units[calc.unit]["plateWidth"]["min"]}`;
      } else if (values.plateWidth2 > units[calc.unit]["plateWidth"]["max"]) {
        errors.plateWidth2 = `Must be less than ${units[calc.unit]["plateWidth"]["max"]}`;
      }

      if (!values.corrosionAllowance && values.corrosionAllowance !== 0) {
        errors.corrosionAllowance = 'Required';
      } else if (values.corrosionAllowance < units[calc.unit]["corrosionAllowance"]["min"]) {
        errors.corrosionAllowance = `Must be greater than ${units[calc.unit]["corrosionAllowance"]["min"]}`;
      } else if (values.corrosionAllowance > units[calc.unit]["corrosionAllowance"]["max"]) {
        errors.corrosionAllowance = `Must be less than ${units[calc.unit]["corrosionAllowance"]["max"]}`;
      }
    }
    
    return errors;
  };
  

  const formik = useFormik({
    initialValues: populateInitalValues(),
    validate,
    enableReinitialize: true,
    
    onSubmit: async (values) => {
      const designStress = Math.round(calculate.designStressByTemp(values.steelGrade, values.temperature));
      
      const res1 = calculate.tankSectionsCalc(calc.unit, designStress, values.height, values.diameter, values.density, values.jointFactor, values.plateWidth, values.steelGrade[0]['Micro'], 0)
      
      const consumption1 = calculate.calcMtrlConsumption(calc.unit, res1, values.steelGrade[0].SteelDensity, values.diameter / 1000);
      
      const designStress2 = !Array.isArray(values.steelGrade2) ? null : Math.round(calculate.designStressByTemp(values.steelGrade2, values.temperature));
      const res2 = !Array.isArray(values.steelGrade2) ? [] : calculate.tankSectionsCalc(calc.unit, designStress2, values.height, values.diameter, values.density, values.jointFactor2, values.plateWidth2, values.steelGrade2[0]['Micro'], values.corrosionAllowance)
      const consumption2 = !Array.isArray(values.steelGrade2) ? null : calculate.calcMtrlConsumption(calc.unit, res2, values.steelGrade2[0].SteelDensity, values.diameter / 1000);
      
      dispatch(changeCalc( { ...calc, ...values, res1:[...res1], consumption1, res2:[...res2], consumption2, submitting: true, submitted: false } ));
      dispatch(changeCalc( { ...calc, ...values, res1:[...res1], consumption1, res2:[...res2], consumption2, submitting: false, submitted: true } ));
    },
  });

  return (
    <form onSubmit={formik.handleSubmit}>
      <Grid container spacing={4}>
        <Fade
          in={true}
          style={{ transformOrigin: 'center right' }}
          {...(true ? { timeout: 250 } : {})}
        >
          <Grid item xs={12} lg={4}>
            <Item>
              <Typography variant="h3" component="h3">YOUR STORAGE TANK REQUIREMENTS</Typography>
              <FormControl fullWidth>
                <Typography variant="label" component="label">
                  Temperature ({units[calc.unit]["temperature"]["sign"]})<br/>
                  {units[calc.unit]["temperature"]["min"]}{units[calc.unit]["temperature"]["sign"]} - {units[calc.unit]["temperature"]["max"]}{units[calc.unit]["temperature"]["sign"]}
                </Typography>
                <TextField
                  name="temperature"
                  type="number"
                  variant="outlined"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.temperature}
                  error={formik.touched.temperature && formik.errors.temperature ? true : false}
                  helperText={formik.errors.temperature}
                />
              </FormControl>
              
              <FormControl fullWidth>
                <Typography variant="label" component="label">
                  Height ({units[calc.unit]["height"]["sign"]})<br/>
                  {units[calc.unit]["height"]["min"]} {units[calc.unit]["height"]["sign"]} - {units[calc.unit]["height"]["max"]} {units[calc.unit]["height"]["sign"]}
                </Typography>
                <TextField
                  name="height"
                  type="number"
                  variant="outlined" 
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.height}
                  error={formik.touched.height && formik.errors.height ? true : false}
                  helperText={formik.errors.height}
                />
              </FormControl>

              <FormControl fullWidth>
                <Typography variant="label" component="label">
                  Diameter ({units[calc.unit]["diameter"]["sign"]})<br/>
                  {units[calc.unit]["diameter"]["min"]} {units[calc.unit]["diameter"]["sign"]} - {units[calc.unit]["diameter"]["max"]} {units[calc.unit]["diameter"]["sign"]}
                </Typography>
                <TextField
                  name="diameter"
                  type="number"
                  variant="outlined" 
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.diameter}
                  error={formik.touched.diameter && formik.errors.diameter ? true : false}
                  helperText={formik.errors.diameter}
                />
              </FormControl>

              <FormControl fullWidth>
                <Typography variant="label" component="label">
                  Density of the liquid being store ({units[calc.unit]["density"]["sign"]}&sup3;)<br/>
                  {units[calc.unit]["density"]["min"]} {units[calc.unit]["density"]["sign"]}&sup3; - {units[calc.unit]["density"]["max"]} {units[calc.unit]["density"]["sign"]}&sup3;
                </Typography>
                <TextField
                  name="density"
                  type="number"
                  variant="outlined" 
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.density}
                  error={formik.touched.density && formik.errors.density ? true : false}
                  helperText={formik.errors.density}
                />
              </FormControl>
            </Item>
          </Grid>
        </Fade>
        <Fade
          in={true}
          style={{ transformOrigin: 'center right' }}
          {...(true ? { timeout: 500 } : {})}
        >
          <Grid item xs={12} lg={4}>
            <Item>
              <Typography variant="h3" component="h3">SELECT A STAINLESS STEEL GRADE</Typography>
              <FormControl fullWidth>
                <Typography variant="label" component="label">Steel grade</Typography>
                <Select
                  name="steelGrade"
                  value={ formik.values.steelGrade }
                  renderValue={() => Array.isArray(formik.values.steelGrade) ? formik.values.steelGrade[0]['OKGrade'] : formik.values.steelGrade }
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.steelGrade && formik.errors.steelGrade ? true : false}
                  IconComponent={KeyboardArrowDownIcon}
                >
                  <DisabledMenuItem key={'Austenitic'} disabled>Austenitic</DisabledMenuItem>
                  {Object.entries(sortedMetals[calc.unit]['Austenitic']).map(([macro]) => 
                      <MenuItem key={`${calc.unit}_Austenitic_${macro}`} value={sortedMetals[calc.unit]['Austenitic'][macro]}>{macro}</MenuItem>
                  )}
                  
                  <DisabledMenuItem key={'Duplex'} disabled>Duplex</DisabledMenuItem>
                  {Object.entries(sortedMetals[calc.unit]['Duplex']).map(([macro]) => 
                      <MenuItem key={`${calc.unit}_Duplex_${macro}`} value={sortedMetals[calc.unit]['Duplex'][macro]}>{macro}</MenuItem>
                  )}
                </Select>
                {formik.errors.steelGrade && 
                <FormHelperText>Required</FormHelperText>}
              </FormControl>

              {(formik.values.temperature || formik.values.temperature===0) && Array.isArray(formik.values.steelGrade) &&
              <FormControl fullWidth>
                <Typography style={{marginTop:'10px'}} variant="label" component="label">
                  Design stress ({units[calc.unit]["designStress"]["sign"]})<br/>
                  {Math.round(calculate.designStressByTemp(formik.values.steelGrade, formik.values.temperature))}
                </Typography>
              </FormControl>}
              
              <FormControl fullWidth>
                <Typography variant="label" component="label">
                  Joint factor
                </Typography>
                <Select
                  name="jointFactor"
                  value={ formik.values.jointFactor }
                  renderValue={() => Array.isArray(formik.values.jointFactor) ? formik.values.jointFactor[0]['OKGrade'] : formik.values.jointFactor}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.jointFactor && formik.jointFactor ? true : false}
                  IconComponent={KeyboardArrowDownIcon}
                >
                  <MenuItem value={1}>1</MenuItem>
                  <MenuItem value={0.85}>0.85</MenuItem>
                  <MenuItem value={0.7}>0.7</MenuItem>
                </Select>
              </FormControl>


              <FormControl fullWidth>
                <Typography variant="label" component="label">
                  Plate width ({units[calc.unit]["plateWidth"]["sign"]})<br/>
                  {units[calc.unit]["plateWidth"]["min"]} {units[calc.unit]["plateWidth"]["sign"]} - {units[calc.unit]["plateWidth"]["max"]} {units[calc.unit]["plateWidth"]["sign"]}
                </Typography>
                <TextField
                  name="plateWidth"
                  type="number"
                  variant="outlined" 
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.plateWidth}
                  error={formik.touched.plateWidth && formik.errors.plateWidth ? true : false}
                  helperText={formik.errors.plateWidth}
                />
              </FormControl>
            </Item>
          </Grid>
        </Fade>
        <Fade
          in={true}
          style={{ transformOrigin: 'center right' }}
          {...(true ? { timeout: 1250 } : {})}
        >
          <Grid item xs={12} lg={4}>
            <Item>
              <Typography variant="h3" component="h3">COMPARE TO STEEL GRADE</Typography>
              <FormControl fullWidth>
                <Typography variant="label" component="label">Steel grade</Typography>
                <Select
                  name="steelGrade2"
                  value={ formik.values.steelGrade2 }
                  renderValue={() => Array.isArray(formik.values.steelGrade2) ? formik.values.steelGrade2[0]['OKGrade'] : formik.values.steelGrade2}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.steelGrade2 && formik.errors.steelGrade2 ? true : false}
                >
                  <DisabledMenuItem key={'Austenitic'} disabled>Austenitic</DisabledMenuItem>
                  {Object.entries(sortedMetals[calc.unit]['Austenitic']).map(([macro]) => 
                      <MenuItem key={`${calc.unit}_Austenitic_${macro}`} value={sortedMetals[calc.unit]['Austenitic'][macro]}>{macro}</MenuItem>
                  )}
                  
                  <DisabledMenuItem key={'Duplex'} disabled>Duplex</DisabledMenuItem>
                  {Object.entries(sortedMetals[calc.unit]['Duplex']).map(([macro]) => 
                      <MenuItem key={`${calc.unit}_Duplex_${macro}`} value={sortedMetals[calc.unit]['Duplex'][macro]}>{macro}</MenuItem>
                  )}

                  <DisabledMenuItemHighlighted key={'Carbon'} disabled>Carbon Steel</DisabledMenuItemHighlighted>
                  {Object.entries(sortedMetals[calc.unit]['Carbon']).map(([macro, grades]) => 
                      <MenuItem key={`${calc.unit}_Carbon_${macro}`} value={sortedMetals[calc.unit]['Carbon'][macro]}>{macro}</MenuItem>
                  )}
                </Select>
              </FormControl>

              {(formik.values.temperature || formik.values.temperature===0) && Array.isArray(formik.values.steelGrade2) &&
              <FormControl fullWidth>
                <Typography style={{marginTop:'10px'}} variant="label" component="label">
                  Design stress ({units[calc.unit]["designStress"]["sign"]})<br/>
                  {Math.round(calculate.designStressByTemp(formik.values.steelGrade2, formik.values.temperature))}
                </Typography>
              </FormControl>}

              <FormControl fullWidth>
                <Typography variant="label" component="label">
                  Joint factor
                </Typography>
                <Select
                  disabled={!Array.isArray(formik.values.steelGrade2)}
                  name="jointFactor2"
                  value={ formik.values.jointFactor2 }
                  renderValue={() => Array.isArray(formik.values.jointFactor2) ? formik.values.jointFactor2[0]['OKGrade'] : formik.values.jointFactor2}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.jointFactor2 && formik.jointFactor2 ? true : false}
                  IconComponent={KeyboardArrowDownIcon}
                >
                  <MenuItem value={1}>1</MenuItem>
                  <MenuItem value={0.85}>0.85</MenuItem>
                  <MenuItem value={0.7}>0.7</MenuItem>
                </Select>
              </FormControl>


              <FormControl fullWidth>
                <Typography variant="label" component="label">
                  Plate Width ({units[calc.unit]["plateWidth"]["sign"]})<br/>
                  {units[calc.unit]["plateWidth"]["min"]} {units[calc.unit]["plateWidth"]["sign"]} - {units[calc.unit]["plateWidth"]["max"]} {units[calc.unit]["plateWidth"]["sign"]}
                </Typography>
                <TextField
                  disabled={!Array.isArray(formik.values.steelGrade2)}
                  name="plateWidth2"
                  type="number"
                  variant="outlined" 
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.plateWidth2}
                  error={formik.touched.plateWidth2 && formik.plateWidth2 ? true : false}
                  helperText={formik.errors.plateWidth2}
                />
              </FormControl>

              <FormControl fullWidth>
                <Typography variant="label" component="label">
                  Corrosion allowance ({units[calc.unit]["corrosionAllowance"]["sign"]})
                  </Typography>
                <TextField
                  disabled={!Array.isArray(formik.values.steelGrade2)}
                  name="corrosionAllowance"
                  type="number"
                  variant="outlined" 
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.corrosionAllowance}
                  error={formik.touched.corrosionAllowance && formik.corrosionAllowance ? true : false}
                  helperText={formik.errors.corrosionAllowance}
                />
              </FormControl>
              <FormControl position="absolute" bottom="0px" fullWidth>
                <Button 
                  variant="contained"
                  type="submit"
                  ref={subBtn}
                  onClick={() => { 
                    /* eslint-disable */
                    if(parent && parent.dataLayer) {
                      parent.dataLayer.push({
                        'event': 'StorageTankClickCalculateBtn'
                      });
                    }
                    /* eslint-enable */
                  }}>
                  Calculate
                </Button>
              </FormControl>
            </Item>
          </Grid>
        </Fade>
      </Grid>
    </form>
  );
}

export default Calculator;